<div class="sticky-bar">
    <div class="w3-container w3-padding-12" style="background:white;">
      <div class="row">
        <div class="w3-col m1 w3-hide-small">
          <img src="../../../assets/activitiesImages/logo_gov.png">
        </div>
        <div class="w3-left w3-margin-top w3-padding-12" style="width: 150px;">
          <img src="../../../assets/activitiesImages/cada_logo.png">
        </div>
        <div class="w3-col m5">
          <!-- <h3 style="font-weight:bold; margin-bottom:0px; margin-top:30px; color: #a91e22; font-size: 1.4rem;">
            Micro
            Irrigation &amp;
            Command Area
            Development Authority, Haryana</h3> -->
            <h3 style="font-weight:bold; margin-bottom:0px; margin-top:30px; color: #a91e22; font-size: 1.4rem;">
              {{'MICADA_HEADING'| translate}}</h3>
          <!-- <span style="color: #a91e22"><b> (Formerly CADA) </b></span> -->
        </div>
      </div>
      <!-- <div class="p-fluid p-formgrid grid">
        <div class="field col-3 md:col-2">
          <img src="../../../assets/activitiesImages/logo_gov.png">
        </div>
        <div class="field col-3 md:col-2">
          <img src="../../../assets/activitiesImages/cada_logo.png">
        </div>
        <div class="field col-6 md:col-6">
          <h3 style="font-weight:bold;margin-bottom:0px;margin-top:30px; width:60%; color: #a91e22; font-size: 1.4rem;">
            Micro
            Irrigation &amp;
            Command Area
            Development Authority, Haryana</h3>
          <span style="color: #a91e22"><b> (Formerly CADA) </b></span>
        </div>
      </div> -->
  
      <div class="w6-col m3 w3-right button-div d-flex" style="text-align: right;">
        <!-- <div class="field-checkbox justify-content-center" style="margin-right:3px;"> 
        
     </div>  -->
     <label><b>{{'LANGUAGE' | translate}} :</b></label>
     <p-dropdown [(ngModel)]="selectedLang"[options]='[{name: "English", code:"en"}, {name: "Hindi",code:"hd"}]' optionLabel="name"
     (onChange)="languageChange($event)" style="margin-left: 2px">
  </p-dropdown>
        <button type="button" class="button-33 mx-3"><a [routerLink]="['/login']"><b>{{'LOGIN'| translate}}</b></a></button>
        <button pButton class="button-33 mx-3" type="button"><a [routerLink]="['/phone-login']"><b>{{'FARMER_LOGIN'| translate}}</b></a></button>
      </div>
    </div>
  
    <!-- Traditional Menu Bar -->
    <section class="top-nav">
      <input id="menu-toggle" type="checkbox" />
      <label class='menu-button-container' for="menu-toggle">
        <div class='menu-button'></div>
      </label>
      <ul class="menu" style="display: flex; justify-content: center;">
        <li><a [routerLink]="['/home']">{{'HOME'| translate}}</a></li>
        <li><a href="https://etenders.hry.nic.in/nicgep/app" target="_blank">{{'TENDER/EOI'| translate}}</a></li>
        <li><a [routerLink]="['/activities']">{{'ACTIVITIES'| translate}}</a></li>
        <li><a [routerLink]="['/officeOrders']">{{'OFFICE_ORDERS'| translate}}</a></li>
        <li><a [routerLink]="['/statistics']">{{'STATISTICS'| translate}}</a></li>
        <li><a href="https://micada.haryana.gov.in:7002/" target="_blank">{{'CADMIS'| translate}}</a></li>
        <li><a [routerLink]="['/rti']">{{'RTI'| translate}}</a></li>
        <li><a [routerLink]="['/new-initiatives']">{{'NEW_INTIATIVES'| translate}}</a></li>
        <li><a [routerLink]="['/org-setup']">{{'ORGANIZATIONAL_SETUP'| translate}}</a></li>
      </ul>
    </section>
  </div>
  
  
  <div class="w3-col m10 w3-margin-top top-container1" style="width: 100%; height: 100%; display: block;">
    <div class="w3-container">
      <p-galleria [value]="images" [responsiveOptions]="responsiveOptions"
        [containerStyle]="{'max-width': '100%', 'height': '100%'}" [numVisible]="5" [showThumbnails]="false"
        [showIndicators]="true" [changeItemOnIndicatorHover]="true" [autoPlay]="true" [transitionInterval]="3000"
        [circular]="true">
        <ng-template pTemplate="item" let-item>
          <img [src]="item.previewImageSrc" style="width: 100%; height: 350px; display: block;" />
        </ng-template>
        <ng-template pTemplate="thumbnail" let-item>
          <div class="grid grid-nogutter justify-content-center">
            <img [src]="item.thumbnailImageSrc" style="display: block;" />
          </div>
        </ng-template>
      </p-galleria>
    </div>
  </div>
  
  
  <div class="row p-0 mt-4 lg:mt-0 pl-5 grid" style="width:100%;">
    <div class="col-12 md:col-4 lg:col-4" style="text-align: center;">
      <img src="../../../assets/activitiesImages/manhorlal.jpg" style="width:150px;height:130px; border-radius: 50%;">
      <p style="font-size:16px; color:rgb(168, 15, 15);"><b>{{'SH_MANOHAR_LAL'| translate}}<p
            style="font-size:12px; color:black; font-weight:bold">{{'CHIEF_MINISTER'| translate}}<br>
            {{'HARYANA'| translate}}</p></b></p>
    </div>
    <div class="col-12 md:col-4 lg:col-4" style="text-align: center;">
      <img src="../../../assets/activitiesImages/ACS.jpg" style="width:150px;height:130px; border-radius: 50%;">
      <p style="font-size:16px; color:rgb(168, 15, 15)"><b>{{'SH_PANKAJ_AGARWAL'| translate}}<p
            style="font-size:12px; color:black; font-weight:bold">{{'COMMMISSIONER_AND_SECRETARY'| translate}},<br>{{'IRRIGATION_AND_WATER_DEPT'| translate}} <br/>{{'HARYANA'| translate}}</p></b></p>
    </div>
    <div class="col-12 md:col-4 lg:col-4" style="text-align: center;">
      <img src="../../../assets/activitiesImages/admin.jpg" style="width:150px;height:130px; border-radius: 50%;">
      <p style="font-size:16px; color:rgb(168, 15, 15)"><b>{{'DR_SATBIR_SINGH'| translate}}<p
            style="font-size:12px; color:black; font-weight:bold">{{'ENGINNER_IN_CHIEF'| translate}}<br>
            {{'ADMINISTRATOR'| translate}}<br>
            {{'CADA_HARYANA'| translate}}</p></b></p><br>
    </div>
  </div>
  
  <!-- <div class="p-fluid p-formgrid grid p-3">
    <div class="field col-12 md:col-2">
      <div class="w3-hover-shadow w3-borderB" style="height:520px; overflow: hidden;">
        <p class="w3-large w3-padding-16" style="background:darkseagreen; color:black; text-align: center"><b>Quick
            Links</b></p>
        <marquee direction="up" onmouseover="this. stop();" onmouseout="this.start();" style="max-height: 430px;">
          <p class="w3-padding-8 w3-left-align px-2">Advertisement date 29/06/2021- for the Post of Director (Communication),
            Director (Agronomy) and Deputy Director (Agronomy).
            <a href="http://cada.hartron.io/assets/home/Appointment%20Regarding%20Document.pdf" target="_blank"><img
                src="../../../assets/activitiesImages/newitem.gif"></a>
          </p>
          <p class="w3-padding-8  w3-left-align px-2">Water Policy 2021<a
              href="http://cada.hartron.io/assets/home/waterpolicy2122.pdf" target="_blank"><img
                src="../../../assets/activitiesImages/newitem.gif"></a></p>
  
          <p class="w3-padding-8  w3-left-align px-2">Farmer Online Application Web Portal for Micro Irrigation<a
              href="http://cada.hartron.io/phone-login" target="_blank">
              <img src="../../../assets/activitiesImages/newitem.gif">
            </a></p>
          <p class="w3-padding-8  w3-left-align px-2">MICADA PORTAL से सम्बंधित योजनाओ की जानकारी हेतु आप हेल्पलाइन संख्या
            0172 - 2800610 पर 9.00 AM to 5.00 PM संपर्क कर सकते है</p>
          <p class="w3-padding-8  w3-left-align px-2">On Farm Water Tank Policy Final- 2020-21
            <a href="http://cada.hartron.io/assets/home/On%20Farm%20Water%20Tank%20Policy%20Final-%202020-21.pdf"
              target="_blank">
              <img src="../../../assets/activitiesImages/newitem.gif"></a>
          </p>
  
          <p class="w3-padding-8  w3-left-align px-2">Implementation Guidelines (Micro Irrigation: 2021-22)
            <a href="http://cada.hartron.io/assets/home/Guidelines%20MI.pdf" target="_blank"><img
                src="../../../assets/activitiesImages/newitem.gif"></a>
          </p>
  
          <p class="w3-padding-8  w3-left-align px-2">MI circular for the year 2021-22<a href="http://cada.hartron.io/home"
              target="_blank"><img src="../../../assets/activitiesImages/newitem.gif"></a></p>
  
          <p class="w3-padding-8  w3-left-align px-2">Aarogya Setu IVRS - Call 1921<a
              href="http://cada.hartron.io/assets/home/AarogyaSetuIVRS.pdf" target="_blank"><img
                src="../../../assets/activitiesImages/newitem.gif"></a></p>
        </marquee>
      </div>
    </div>
  
    <div class="field col-12 md:col-8">
      <div class="w3-hover-shadow w3-borderB middle-content" style="height:520px; overflow: scroll;">
        <p class="w3-large px-2" style="color:rgb(22, 21, 21); background:darkseagreen;"><b>ONGOING PROJECTS</b></p>
  
        <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;"><b>Three
            projects namely WJC-VI, JLN-II & BCC-II were approved under
            CADWM Programme,
            wherein WJC Canal Command Ph-VI and JLN Canal Command Ph–II projects were included during the financial year
            2007-08 under CADWM programme by GOI,
            MOWR vide sanction letter NO.13-6/2006-CADWM dated 06.02.2008 and Bhakra Canal Command Phase-II Project was
            included under CADWM Programme by Government
            of India MOWR vide sanction letter dated 25.05.2009 during the financial year 2009-10. Now, due to
            discontinuation of CADWM Programme by Government of India in the year 2016, these projects are being executed
            from state funds since 2016-17.</b></p>
  
        <p class="w3-large px-2" style="color:rgb(22, 21, 21); background:darkseagreen;"><b>BRIEF DETAIL OF ONGOING
            PROJECTS BEING
            EXECUTED IS AS UNDER</b></p>
  
        <b style="margin-left:12px;">1. WESTERN JAMUNA CANAL COMMAND PH-VI PROJECT</b>
        <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;"><b>As per DPR,
            under this Project an area of 2,05,600 ha. CCA will be
            covered by constructing 1542 watercourses with an estimated
            cost of Rs. 459.92 crore. The farmers of Rohtak, Jhajjar, Sonepat, Jind, Bhiwani, Gurugram, Panipat & Karnal
            districts are being
            benefited under this project. 173514 ha. CCA has been covered by constructing 1044 watercourses under this
            project.</b></p>
  
        <b style="margin-left:12px;">2. JLN CANAL COMMAND PHASE II PROJECT</b>
        <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;"><b>As per DPR,
            under this Project 99,383 ha. CCA was to be covered by
            constructing 525 watercourses.
            But, MoU for covering 74537 ha. CCA was signed with a revised estimated cost of Rs. 205.07 crore. The farmers
            of Jhajjar, Rewari, Gurugram, Mahendragarh
            & Bhiwani districts are being benefited under this project. 13488 ha. CCA has been covered by constructing 119
            watercourses under this project.</b></p>
        <b style="margin-left:12px;">3. BHAKRA CANAL COMMAND PHASE-II PROJECT</b>
        <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;"><b>As per DPR,
            under this Project 351853 ha. CCA will be covered by
            constructing 1982 watercourses with an
            estimated cost of Rs. 815.18 crore. The farmers of Hisar, Sirsa, Fatehabad, Ambala, Kurukshetra, Kaithal,
            Karnal & Jind districts are being benefited
            under this project. 304225 ha. CCA has been covered by constructing 1648 watercourses under this project.</b>
        </p><br>
      </div>
    </div>
  
    <div class="field col-12 md:col-2">
      <div class="w3-hover-shadow w3-borderB" style="height:520px; overflow: hidden;">
        <p class="w3-large w3-padding-16" style="background:darkseagreen; color:black; text-align: center"><b>News &
            Events</b></p>
        <marquee direction="up" onmouseover="this. stop();" onmouseout="this.start();" style="max-height: 430px;">
          <div class="w3-padding-16 w3-left-align px-2"><b>FARMER ONLINE APPLICATION FOR MI</b><br>
            <p>FARMER ONLINE APPLICATION has been inaugurated by Hon'ble Chief Minister Haryana on dated 16/01/2021</p>
          </div>
          <div class="w3-padding-16  w3-left-align px-2"><b>CADA Administrator</b><br>
            <p>Dr. Satbir Singh Kadian, EIC, Administrator CADA Haryana Panchkula</p>
          </div>
          <div class="w3-padding-16  w3-left-align px-2"><b>CADA Chief Engineer</b><br>
            <p>Sh. Suresh Yadav, Chief Engineer, CADA Haryana Panchkula</p>
          </div>
        </marquee>
      </div>
    </div>
  </div> -->
  
  
  <div class="px-3">
    <div class="w3-col m2 w3-container w3-margin-bottom info-container1 w3-center w3-hover-shadow w3-border">
      <ul class="w3-ul w3-margin-top" style="font-size:12px;">
  
        <li class="w3-large w3-padding-16" style="background:darkseagreen; color:black"><b>{{'QUICK_LINKS'| translate}}</b></li>
        <marquee direction="up" onmouseover="this. stop();" onmouseout="this.start();" style="max-height: 430px;">
          <li class="w3-padding-8 w3-left-align">{{'ADVERTISEMENT_DATE'| translate}}
            <a href="http://cada.hartron.io/assets/home/Appointment%20Regarding%20Document.pdf" target="_blank"><img
                src="../../../assets/activitiesImages/newitem.gif"></a>
          </li>
          <li class="w3-padding-8  w3-left-align">{{'WATER_POLICY'| translate}}<a
              href="http://cada.hartron.io/assets/home/waterpolicy2122.pdf" target="_blank"><img
                src="../../../assets/activitiesImages/newitem.gif"></a></li>
  
          <li class="w3-padding-8  w3-left-align">{{'FARMER_ONLINE_APP_WEB_PORTAL_FOR_MI'| translate}}<a
              href="http://cada.hartron.io/phone-login" target="_blank">
              <img src="../../../assets/activitiesImages/newitem.gif">
            </a></li>
          <li class="w3-padding-8  w3-left-align">MICADA PORTAL से सम्बंधित योजनाओ की जानकारी हेतु आप हेल्पलाइन संख्या
            0172 - 2800610 पर 9.00 AM to 5.00 PM संपर्क कर सकते है</li>
          <li class="w3-padding-8  w3-left-align">{{'ON_FARM_WATER_TANK_POLICY'| translate}}
            <a href="http://cada.hartron.io/assets/home/On%20Farm%20Water%20Tank%20Policy%20Final-%202020-21.pdf"
              target="_blank">
              <img src="../../../assets/activitiesImages/newitem.gif"></a>
          </li>
  
          <li class="w3-padding-8  w3-left-align">{{'IMPLEMENTATION_GUIDELINES'| translate}}
            <a href="http://cada.hartron.io/assets/home/Guidelines%20MI.pdf" target="_blank"><img
                src="../../../assets/activitiesImages/newitem.gif"></a>
          </li>
  
          <li class="w3-padding-8  w3-left-align">{{'MI_CIRCULAR'| translate}}<a href="http://cada.hartron.io/home"
              target="_blank"><img src="../../../assets/activitiesImages/newitem.gif"></a></li>
  
          <li class="w3-padding-8  w3-left-align">{{'AAROGYA_SETU_IVRS'| translate}}<a
              href="http://cada.hartron.io/assets/home/AarogyaSetuIVRS.pdf" target="_blank"><img
                src="../../../assets/activitiesImages/newitem.gif"></a></li>
        </marquee>
      </ul>
    </div>
  
  
    <div class="w3-col m8 w3-container w3-margin-bottom info-container2 w3-center w3-hover-shadow w3-borderB">
      <ul class="w3-ul w3-margin-top" style="font-size:12px;">
        <h5 style="color:rgb(22, 21, 21); background:darkseagreen;" class="px-3 pt-1"><b>ACRs Porforma</b></h5>
  
        <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
            <!-- <p class="w3-padding-8 w3-left-align"> -->
                <a href="http://cada.hartron.io/assets/home/ACRs%proforma.pdf"
                    target="_blank">{{'Porforma 1'| translate}}.</a>
            <!-- </p> -->
      </ul>
    </div>
  
    <div class="w3-col m2 w3-container w3-margin-bottom info-container3 w3-center w3-hover-shadow w3-border">
      <ul class="w3-ul w3-margin-top" style="font-size:12px;">
  
        <li class="w3-large w3-padding-16" style="background:darkseagreen; color:black"><b>{{'NEWS_AND_EVENTS'| translate}}</b></li>
        <marquee direction="up" onmouseover="this. stop();" onmouseout="this.start();" style="max-height: 430px;">
          <li class="w3-padding-16 w3-left-align"><b>{{'FARMER_ONLINE_APPLICATION_FOR_MI'| translate}}</b><br>
            <p>{{'FARMER_ONLINE_APPLICATION_HAS_BEEN_INAUGURATED'| translate}}</p>
          </li>
          <li class="w3-padding-16  w3-left-align"><b>{{'CADA_ADMINISTRATOR'| translate}}</b><br>
            <p>{{'DR_SATBIR_SINGH_KADIAN_EIC'| translate}}</p>
          </li>
  
          <li class="w3-padding-16  w3-left-align"><b>{{'CADA_CHIEF_ENGINEER'| translate}}</b><br>
            {{'SH_SURESH_YADAV'| translate}}</li>
  
          <li class="w3-padding-24 w3-left-align"></li>
          <li class="w3-padding-16 w3-left-align"></li>
        </marquee>
      </ul>
    </div>
  </div>
  
  
  <div class="grid col-12 md:col-12 lg:col-12 p-0 mt-4 lg:mt-0 pl-5" style="width:100%;">
    <div class="col-6 md:col-2 lg:col-2 pr-5 p-0 lg:pr-5  mt-4 lg:mt-0 mb-2 dropdown">
        <div class="px-3" style="
            height: 160px;
            padding: 2px;
            border-radius: 10px;
            background: linear-gradient(
                90deg,
                rgba(253, 228, 165, 0.2),
                rgba(187, 199, 205, 0.2)
              ),
              linear-gradient(
                180deg,
                rgba(253, 228, 165, 0.2),
                rgba(187, 199, 205, 0.2)
              );
          ">
            <a class="p-3 h-full" style="border-radius: 8px">
                <div class="flex align-items-center justify-content-center bg-yellow-200 mb-3"
                    style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                    <i class="pi pi-fw pi-money-bill text-2xl text-yellow-700"></i>
                </div>
                <h5 class="mb-2 text-900">{{'FARMER_SHARE_PAYMENT'| translate}}</h5>
                <div class="dropdown-content">
                    <a href="assets/home/farmer_share_payment_s1.pdf" target="_blank">{{'FARMER_SHARE_LOT_1'| translate}}</a>
                    <a href="assets/home/farmer_share_payment_s2.pdf" target="_blank">{{'FARMER_SHARE_LOT_2'| translate}}</a>
                    <a href="assets/home/farmer_share_payment_s3.pdf" target="_blank">{{'FARMER_SHARE_LOT_3'| translate}}</a>
                    <a href="assets/home/farmer_share_payment_s4.pdf" target="_blank">{{'FARMER_SHARE_LOT_4'| translate}}</a>
                    <a href="assets/home/farmer_share_payment_s5.pdf" target="_blank">{{'FARMER_SHARE_LOT_5'| translate}}</a>
                </div>
            </a>
        </div>
    </div>
  
    <div class="col-6 md:col-2 lg:col-2 pr-5 p-0 lg:pr-5  mt-4 lg:mt-0 mb-2">
        <div class="px-3" style="
            height: 160px;
            padding: 2px;
            border-radius: 10px;
            background: linear-gradient(
                90deg,
                rgba(145, 226, 237, 0.2),
                rgba(251, 199, 145, 0.2)
              ),
              linear-gradient(
                180deg,
                rgba(253, 228, 165, 0.2),
                rgba(172, 180, 223, 0.2)
              );
          ">
            <a [routerLink]="['/evaluation-study']" class="p-3  h-full" style="border-radius: 8px">
                <div class="flex align-items-center justify-content-center bg-cyan-200 mb-3"
                    style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                    <i class="pi pi-fw pi-palette text-2xl text-cyan-700"></i>
                </div>
                <h5 class="mb-2 text-900">{{'EVALUATION_STUDY'| translate}}</h5>
            </a>
        </div>
    </div>
  
    <div class="col-6 md:col-2 lg:col-2 p-0 pr-5 lg:pr-5 mt-4 lg:mt-0">
        <div class="px-3" style="
            height: 160px;
            padding: 2px;
            border-radius: 10px;
            background: linear-gradient(
                90deg,
                rgba(145, 226, 237, 0.2),
                rgba(172, 180, 223, 0.2)
              ),
              linear-gradient(
                180deg,
                rgba(172, 180, 223, 0.2),
                rgba(246, 158, 188, 0.2)
              );
          ">
            <a [routerLink]="['/micro-irrigation']" class="p-3 h-full" style="border-radius: 8px">
                <div class="flex align-items-center justify-content-center bg-indigo-200"
                    style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                    <i class="pi pi-fw pi-map text-2xl text-indigo-700"></i>
                </div>
                <h5 class="mb-2 text-900">{{'MICRO_IRRIGATION'| translate}}</h5>
            </a>
        </div>
    </div>
  
    <div class="col-6 md:col-2 lg:col-2 pr-5 p-0 lg:pr-5  mt-4 lg:mt-0 mb-2">
        <div class="px-3" style="
            height: 160px;
            padding: 2px;
            border-radius: 10px;
            background: linear-gradient(
                90deg,
                rgba(187, 199, 205, 0.2),
                rgba(251, 199, 145, 0.2)
              ),
              linear-gradient(
                180deg,
                rgba(253, 228, 165, 0.2),
                rgba(145, 210, 204, 0.2)
              );
          ">
            <a [routerLink]="['/project']" class="p-3 h-full" style="border-radius: 8px">
                <div class="flex align-items-center justify-content-center bg-bluegray-200 mb-3"
                    style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                    <i class="pi pi-fw pi-id-card text-2xl text-bluegray-700"></i>
                </div>
                <h5 class="mb-2 text-900">{{'PROJECTS'| translate}}</h5>
            </a>
        </div>
    </div>
  
    <div class="col-6 md:col-2 lg:col-2 p-0 pr-5 lg:pr-5  mt-4 lg:mt-0">
        <div class="px-3" style="
            height: 160px;
            padding: 2px;
            border-radius: 10px;
            background: linear-gradient(
                90deg,
                rgba(187, 199, 205, 0.2),
                rgba(246, 158, 188, 0.2)
              ),
              linear-gradient(
                180deg,
                rgba(145, 226, 237, 0.2),
                rgba(160, 210, 250, 0.2)
              );
          ">
            <a [routerLink]="['/annual-plan']" class="p-3 h-full" style="border-radius: 8px">
                <div class="flex align-items-center justify-content-center bg-orange-200 mb-3"
                    style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                    <i class="pi pi-fw pi-star text-2xl text-orange-700"></i>
                </div>
                <h5 class="mb-2 text-900">{{'ANNUAL_PLAN'| translate}}</h5>
            </a>
        </div>
    </div>
  
    <div class="col-6 md:col-2 lg:col-2 p-0 pr-5 lg:pr-5  mt-4 lg:mt-0">
        <div class="px-3" style="
      height: 160px;
      padding: 2px;
      border-radius: 10px;
      background: linear-gradient(
          90deg,
          rgba(251, 199, 145, 0.2),
          rgba(246, 158, 188, 0.2)
        ),
        linear-gradient(
          180deg,
          rgba(172, 180, 223, 0.2),
          rgba(212, 162, 221, 0.2)
        );">
            <a [routerLink]="['/achievements']" class="p-3 h-full" style="border-radius: 8px">
                <div class="flex align-items-center justify-content-center bg-orange-200 mb-3"
                    style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                    <i class="pi pi-fw pi-star text-2xl text-orange-700"></i>
                </div>
                <h5 class="mb-2 text-900">{{'ACHIEVEMENTS'| translate}}</h5>
            </a>
        </div>
    </div>
  </div>
  
  
  
  <!-- Grid end -->
  <div class="w3-row-padding bottom-content" id="plans">
  
    <div class="w3-third w3-margin-bottom w3-margin-top ">
      <ul class="w3-ul w3-border w3-center w3-hover-shadow bottom-content-box">
        <li class="w3-large w3-padding-32" style="background:darkseagreen; color:black;"><b>{{'UPCOMING_PROJECTS'| translate}}</b></li>
        <li class="w3-padding-16">{{'UPCOMING_PROJECT1'| translate}}</li>
        <li class="w3-padding-16">{{'UPCOMING_PROJECT2'| translate}}</li>
        <li class="w3-padding-16">{{'UPCOMING_PROJECT3'| translate}}</li>
  
        <li class="w3-light-grey w3-padding-24">
          <button class="w3-button w3-padding-large" style="background:darkseagreen;">{{'VIEW_MORE'| translate}}</button>
        </li>
      </ul>
    </div>
  
    <div class="w3-third w3-margin-bottom w3-margin-top ">
      <ul class="w3-ul w3-border w3-center w3-hover-shadow bottom-content-box">
        <li class="w3-large w3-padding-32" style="background:darkseagreen; color:black;"><b>{{'ON_GOING_PROJECTS'| translate}}</b></li>
        <li class="w3-padding-16">{{'ON_GOING_PROJECT1'| translate}}
        </li>
        <li class="w3-padding-16">{{'ON_GOING_PROJECT2'| translate}}</li>
        <li class="w3-padding-16">{{'ON_GOING_PROJECT3'| translate}}</li>
  
        <li class="w3-light-grey w3-padding-24">
          <button class="w3-button w3-padding-large" style="background:darkseagreen;">{{'VIEW_MORE'| translate}}</button>
        </li>
      </ul>
    </div>
  
    <div class="w3-third w3-margin-bottom w3-margin-top ">
      <ul class="w3-ul w3-border w3-center w3-hover-shadow bottom-content-box">
        <li class="w3-large w3-padding-32" style="background:darkseagreen; color:black;"><b>{{'IMPORTANT_LINKS'| translate}}</b></li>
        <li class="w3-padding-10 w3-text-blue"><a href="http://hrcada.attendance.gov.in/"
            target="_blank">http://hrcada.attendance.gov.in/</a></li>
        <li class="w3-padding-10 w3-text-blue"><a href="http://web1.hry.nic.in/cfmshcs/"
            target="_blank">http://web1.hry.nic.in/cfmshcs/</a></li>
        <li class="w3-padding-10 w3-text-blue"><a href="http://lmshry.gov.in/" target="_blank">http://lmshry.gov.in/</a>
        </li>
        <li class="w3-padding-10 w3-text-blue"><a href="https://etenders.hry.nic.in/nicgep/app"
            target="_blank">https://etenders.hry.nic.in/nicgep/app</a></li>
        <li class="w3-padding-10 w3-text-blue"><a href="http://hrmshry.nic.in/" target="_blank">http://hrmshry.nic.in/</a>
        </li>
        <li class="w3-padding-10 w3-text-blue"><a href="http://www.hid.gov.in/" target="_blank">http://www.hid.gov.in/</a>
        </li>
        <li class="w3-padding-10 w3-text-blue"><a href="http://www.apprenticeship.gov.in"
            target="_blank">http://www.apprenticeship.gov.in</a></li>
        <li class="w3-padding-10 w3-text-blue"><a href="https://pgportal.gov.in/"
            target="_blank">https://pgportal.gov.in/</a></li>
      </ul>
    </div>
  </div>
  
  
  <footer class="w3-container w3-center" style="background:darkseagreen;height:120px; color:black;">
    <div class="w3-row-padding">
      <div class="w3-center w3-bar-item" style="margin-bottom:5px; color:black;">
        <p><b><strong>{{'MICADA_HARYANA'| translate}}</strong></b><br><b>
          {{'BAYS_39_40_SECTOR_4_PANCHKULA'| translate}}<br>
          {{'FAX_NO'| translate}}<br>
          {{'EMAIL'| translate}}:hrcada@chd.nic.in</b></p>
        <p class="w3-hide-medium w3-hide-small" style="color:rgb(71, 3, 3);"><b>
           Copyright © 2021 Micro Irrigation &
            Command Area Development Authority, Haryana. All Rights Reserved.</b>
        </p>
      </div>
    </div>
  </footer>